import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiRequest } from "../../lib/api";
import "../MailchimpAlternative/MailchimpAlternative.css";
import "../SeoLandingPage/SeoLandingPage.css";
import "./Contact.css";

const initialForm = {
  name: "",
  email: "",
  description: "",
};

export default function Contact() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const updateField = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("loading");
    setMessage("");

    try {
      await apiRequest("/inquiries", {
        method: "POST",
        body: JSON.stringify({
          name: form.name.trim(),
          email: form.email.trim(),
          description: form.description.trim(),
        }),
      });

      setForm(initialForm);
      setStatus("success");
      setMessage("Thanks, your inquiry has been sent. The Mailsnappy team will get back to you soon.");
    } catch (error) {
      setStatus("error");
      setMessage(error.message || "We could not send your inquiry right now. Please email support@mailsnappy.com.");
    }
  };

  return (
    <main className="mailchimp-page contact-page">
      <section className="mailchimp-hero contact-hero">
        <div className="mailchimp-hero-copy">
          <span className="mailchimp-eyebrow">Contact Mailsnappy</span>
          <h1>Contact Us</h1>
          <p>
            Have a question about Mailsnappy email marketing software, campaign tools,
            templates, automation, or pricing? Send us a message and we will help.
          </p>
          <div className="mailchimp-actions">
            <a href="mailto:support@mailsnappy.com">Email support@mailsnappy.com</a>
            <Link className="secondary" to="/faq">Visit email marketing FAQ</Link>
          </div>
        </div>

        <form className="contact-form-card" onSubmit={handleSubmit}>
          <div className="seo-landing-window" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>

          <label htmlFor="contact-name">Name</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            value={form.name}
            onChange={updateField}
            placeholder="Your name"
            autoComplete="name"
            required
          />

          <label htmlFor="contact-email">Email</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            value={form.email}
            onChange={updateField}
            placeholder="you@company.com"
            autoComplete="email"
            required
          />

          <label htmlFor="contact-description">How can we help?</label>
          <textarea
            id="contact-description"
            name="description"
            value={form.description}
            onChange={updateField}
            placeholder="Tell us about your email marketing needs, campaign goals, audience size, or the Mailsnappy feature you want to learn about."
            rows="6"
            required
          />

          <button type="submit" disabled={status === "loading"}>
            {status === "loading" ? "Sending..." : "Send inquiry"}
          </button>

          {message ? (
            <p className={`contact-form-message ${status === "error" ? "error" : "success"}`} role="status">
              {message}
            </p>
          ) : null}
        </form>
      </section>

      <section className="mailchimp-proof contact-options">
        <article>
          <h2>Product questions</h2>
          <p>Ask about email campaigns, automation, templates, segmentation, analytics, or getting started.</p>
        </article>
        <article>
          <h2>Support email</h2>
          <p>
            You can also write directly to{" "}
            <a href="mailto:support@mailsnappy.com">support@mailsnappy.com</a>.
          </p>
        </article>
        <article>
          <h2>Useful resources</h2>
          <p>
            Browse the <Link to="/pricing">pricing page</Link>, <Link to="/templates">email templates</Link>,
            or <Link to="/email-marketing-software">email marketing software</Link> overview.
          </p>
        </article>
      </section>
    </main>
  );
}
